<template>
  <div
    v-if="accessories.length > 0 && !isBot"
    class="l-container content-block l-description-grid"
  >
    <ModelSimilar
      :is-tablet="isTablet"
      :is-mobile="isMobile"
      :similar="accessories"
      title="Аксессуары"
      type="accessories"
      :show-more-button="false"
      :model-id="props.pageData.model.id"
      :page-data="props.pageData"
      :changed-page="props.pageData.changedPage"
      full-width-mobile
      @change-data="(e) => emit('change-data', e)"
    />
  </div>
  <div
    v-if="accessories.length > 0 && !isBot"
    class="l-container content-block"
  >
    <div
      v-if="props.seoData"
      id="description-model"
      class="l-description l-description-grid"
    >
      <PageModelDescriptionModel :seo-data="props.seoData" />
    </div>
  </div>
</template>
<script lang="ts" setup>
import { useMediaQueryStore } from '~/stores/mediaQuery';
import { useGlobalStore } from '~/stores/global';

const mediaQuery = useMediaQueryStore();
const globalStore = useGlobalStore();
const isMobile = computed(() => mediaQuery.isMobile);
const isTablet = computed(() => mediaQuery.isTablet);
const emit = defineEmits(['change-data']);
const isBot = computed(() => globalStore.isBot);
const accessories = computed(() => props.pageData?.accessories || []);
const props = defineProps({
  pageData: {
    type: Object as () => any,
    required: true,
  },
  seoData: {
    type: Object as () => any,
    required: true,
  },
});
</script>
<style lang="scss" scoped>
.title {
  margin-bottom: 16px;
  @include xl-block {
    margin-bottom: 24px;
  }
}
.content-block {
  margin-top: 8px;
  @include xl-block {
    margin-top: 20px;
  }
}
</style>
